"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Percent = void 0;
var assert_1 = __importDefault(require("assert"));
var Percent = /** @class */ (function () {
    function Percent(value, options) {
        this.value = value;
        this.value = Math.round(value);
        if (!(options === null || options === void 0 ? void 0 : options.allowUnder0) && value < 0) {
            console.log("Percent value must be >= 0. Received: ".concat(value));
            this.value = 0;
        }
        if (!(options === null || options === void 0 ? void 0 : options.allowOver100) && value > 100) {
            console.log("Percent value must be <= 100. Received: ".concat(value));
            this.value = 100;
        }
    }
    Percent.fromDecimal = function (value, options) {
        return new Percent(value * 100, options);
    };
    Percent.averageOf = function (percents) {
        (0, assert_1.default)(percents.length > 0, "Can't average no percent");
        return new Percent(percents.reduce(function (sum, percent) { return sum + percent.value; }, 0) /
            percents.length);
    };
    Percent.fromBoolean = function (value) {
        return new Percent(value ? 100 : 0);
    };
    Percent.prototype.withMinimum = function (percent) {
        return new Percent(Math.max(this.value, percent.value));
    };
    Percent.prototype.toString = function () {
        return "".concat(this.value, "%");
    };
    Object.defineProperty(Percent.prototype, "isCertain", {
        get: function () {
            return this.value === 100;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Percent.prototype, "tailwindColor", {
        get: function () {
            if (this.value >= 80)
                return 'v5-green';
            if (this.value >= 40)
                return 'v5-blue';
            return 'v5-red';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Percent.prototype, "label", {
        get: function () {
            if (this.value >= 95)
                return 'Peak Mastery';
            if (this.value >= 80)
                return 'Great';
            if (this.value >= 60)
                return 'Good';
            if (this.value >= 40)
                return 'Fair';
            return 'A Good Start';
        },
        enumerable: false,
        configurable: true
    });
    return Percent;
}());
exports.Percent = Percent;
